const initialState = {
    messages: 0
};

const MessagerieReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case 'CHECK_MESSAGES':
            return {
                ...state,
                messages: action.payload
            };
        default:
            return state;
    }
};

export default MessagerieReducer;
